import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AreaModel } from '../models/area';
import { EndpointsService } from './endpoints.service';
import { Observable } from 'rxjs';
import { ModalControlService } from './modal-control.service';
import { MapService } from './map.service';
import { ModalConfirmationService } from './modal-confirmation.service';
import { ConfigurationService } from './configuration.service';
import { UserSettingsService } from './userSettings.service';
import { UiBlockService } from './ui-block.service';

@Injectable({
  providedIn: 'root'
})
export class AreaService {

  public areas : Map<Number, AreaModel> = new Map<Number, AreaModel>();
  constructor(private endpointService : EndpointsService,
    private http : HttpClient,
    private modalService : ModalControlService,
    private mapService : MapService,
    private modalConfirmation : ModalConfirmationService,
    private configurationService : ConfigurationService,
    private userSettingsService: UserSettingsService,
    private uiBlock: UiBlockService
    ) { }

  ngOnInit(): void {
    //this.areas = new Map<Number, AreaModel>();
  }

  createArea(area : AreaModel): void{
    this.saveArea(AreaModel.mapToService(area)).subscribe((res) => {
      if(area.defaultArea){
        this.areas.forEach(area => {
          area.defaultArea = false;
        })
      }
      this.areas.set(res.id, res);
      this.modalService.showMesssageModal("Success","Changes to Areas were saved successfully")
    },
    (error) => {
      if (error && error.status == 401) {
        this.modalService.showMesssageModal(
          'Error',
          'Default Project is not editable.'
        )
        return;
      }
      this.modalService.showMesssageModal("Error", "An error occured creating the area");
    });
  }

  openArea(area : AreaModel): void{
    if(area != null){
      this.mapService.setAreaView(area?.latitude, area?.longitude, area?.zoom);
    }
  }

  deleteArea(area : AreaModel): void{
    this.modalConfirmation.showMesssageConfirmationModal("Delete Areas of Interest", "Do you wish to remove this area of interest?", "Yes", "No", () =>{
      this.deleteDBArea(area.id).subscribe((res) => {
        if(res){
          this.areas.delete(area.id);
        }
        else{
          this.modalService.showMesssageModal('Error', 'An error occured on delete the area "' + area.name +'"');
        }
      },
      (error) => {
        if (error && error.status == 401) {
          this.modalService.showMesssageModal(
            'Error',
            'Default Project is not editable.'
          )
          return;
        }
        this.modalService.showMesssageModal("Error", "An error occured deleting the area");
      })
    })
  }

  fetchAllAreasAndSetDefault(isSwitchProject: boolean = false, onComplete?: () => void): void{
    isSwitchProject? this.uiBlock.startBlock("Adding entities to map..."): false;
    this.areas.clear();
    this.getAllAreas().subscribe((areas) => {
      try {
        let foundDefault : boolean = false;
        areas.forEach(obtainedArea => {
          let area : AreaModel = AreaModel.map(obtainedArea);
          this.areas.set(area.id, area);
          if(area.defaultArea && this.configurationService.currentConfiguration.display.startDefaultArea){
            this.openArea(area);
            foundDefault = true;
          }
        });
        if(!foundDefault){
          this.openArea(null);
        }
      } finally {
        isSwitchProject? this.uiBlock.stopBlock(): false;
        if (onComplete) onComplete();
      }
    },
    () => {
      isSwitchProject? this.uiBlock.stopBlock(): false;
    })
  }

  getArea(): Observable<AreaModel[]> {
    return this.http.get<AreaModel[]>(
      this.endpointService.apiUrlAreas,
      this.endpointService.httpOptions
    );
  }

  private getAllAreas() : Observable<AreaModel[]>{
    return this.http.get<AreaModel[]>(
      this.endpointService.apiUrlAreas + '/list',
      this.endpointService.httpOptions
      )
  }

  saveArea(area: AreaModel): Observable<any>{
    if (area.id == null) {
      return this.http
        .post<any>(
          this.endpointService.apiUrlAreas,
          area,
          this.endpointService.httpOptions
        );
    } else {
      return this.http
        .put<any>(
          this.endpointService.apiUrlAreas,
          area,
          this.endpointService.httpOptions
        );
    }
  }

  async saveAreaAsync(area: AreaModel): Promise<any>{
    if (area.id == null) {
      return this.http
        .post<any>(
          this.endpointService.apiUrlAreas,
          area,
          this.endpointService.httpOptions
        );
    } else {
      return this.http
        .put<any>(
          this.endpointService.apiUrlAreas,
          area,
          this.endpointService.httpOptions
        );
    }
  }

  deleteAllAreas(): void{
    this.modalConfirmation.showMesssageConfirmationModal("Delete Areas of Interest", "Do you wish to remove all areas of interest?", "Yes", "No", () =>{
      this.areas.forEach(el => {
        this.deleteDBArea(el.id).subscribe(res => {
          if(!res){
            this.modalService.showMesssageModal('Error', 'An error occured on delete Areas');
          }
          else{
            this.areas.delete(el.id);
          }
        },
        (error) => {
          if (error && error.status == 401) {
            this.modalService.showMesssageModal(
              'Error',
              'Default Project is not editable.'
            )
            return;
          }
          this.modalService.showMesssageModal("Error", "An error occured deleting the area");
        });
      });
    })
  }

  private deleteDBArea(id: number): Observable<boolean> {
    return this.http
      .delete<boolean>(
        this.endpointService.apiUrlAreas + '/' + id,
        this.endpointService.httpOptions
      );
  }
}
